import React from 'react';

import { Typography } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface CategorySectionProps {
  className?: string;
  children?: React.ReactNode;
  section: string;
  'data-testid'?: string;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  section,
  'data-testid': dataTestId,
  className,
  children,
}) => (
  <div className={cn('my-8', className)} data-testid={dataTestId}>
    <Typography variant="overline1" className="mb-2!">
      {section}
    </Typography>
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">{children}</div>
  </div>
);

export default CategorySection;
